export const notificationTemplate = (classMod, text) => {
  return `<div class="modal-feedback ${classMod}">
  <div class="modal-feedback__description">
    <p>${text}</p>
  </div>
</div>`;
};
